import {PureComponent} from 'react'
import {Field, reduxForm} from 'redux-form'

import Select from '../../Form/Field/Select.jsx'
import validate from './validate.js'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import conf from '../../../conf.js'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import LanguageTypeahead from '../../Form/Field/LanguageTypeahead.jsx'

import './LanguageForm.scss'

export const name = 'LanguageForm'

class LanguageForm extends PureComponent {
  constructor(props) {
    super(props)
    this.props.initialize({level: conf.languageLevels.native.value})
  }

  handleSubmit = (values) => {
    this.props.handleSubmit(values)
  }

  render() {
    return (
      <div id={name} className="language-form">
        <form autoComplete="off" onSubmit={this.handleSubmit}>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
          <div className="row align-items-end">
            <div className="col-xl-6">
              <Field
                label="Langue"
                name="language"
                placeholder="Entrez le nom d'une langue"
                component={LanguageTypeahead}/>
            </div>
            <div className="col-xl-6">
              <Field
                label="Niveau"
                name="level"
                type="text"
                component={Select}>
                {Object.values(conf.languageLevels).map((level) => (
                  <option value={level.value} key={level.value}>{level.label}</option>
                ))}
              </Field>
            </div>
            <input className="d-none" type="submit" />
          </div>
        </form>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(LanguageForm)
